// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-messages .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){background-color:transparent!important;margin-top:3px;margin-right:0}.global-messages .v-alert h4{margin-bottom:0!important;font-size:1.25rem}", ""]);
// Exports
module.exports = exports;
